import { render } from "./GridHeaderCell.vue?vue&type=template&id=0ca3c4a2&scoped=true&ts=true"
import script from "./GridHeaderCell.vue?vue&type=script&lang=ts"
export * from "./GridHeaderCell.vue?vue&type=script&lang=ts"

import "./GridHeaderCell.vue?vue&type=style&index=0&id=0ca3c4a2&lang=scss&scoped=true"

import exportComponent from "C:\\TeamCityBuildAgent\\work\\623dcfb411009e26\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca3c4a2"]])

export default __exports__